
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class PickFooter extends Vue {
  @Prop({ type: String, required: true }) readonly currentStep!: string

  @Prop({ type: Number, default: 0 }) readonly pickPage!: number

  @Prop({ type: Number, default: 0 }) readonly productsLength!: number

  @Prop({ type: Number, default: 0 }) readonly docLength!: number

  @Prop({ type: Array, required: true }) readonly products!: any[]
}
